import { dateFormatters } from '@insurancemenu/imenu-components-lib/dist/helpers';
import { addOrUpdateDependent } from 'api/operations/electionService';
import { makeAutoObservable, runInAction } from 'mobx';
import { PersonInfo } from 'types/electionService';
import { SubscriberPersonInfo } from '../types';

export interface DependentMainData {
  id: string;
  fullName: string;
  dateOfBirth: string;
  memberType: string;
}

interface DomainParams {
  dependent: SubscriberPersonInfo;
  subscriberId: string;
}

export default class SubDependentDelegate {
  private _dependent: SubscriberPersonInfo;
  private _subscriberId: string;

  public get dependent(): SubscriberPersonInfo {
    return this._dependent;
  }

  public get mainData(): DependentMainData {
    const { id, firstName, middleName, lastName, dob, type } = this._dependent;
    return {
      id: id ?? '',
      fullName: `${firstName} ${middleName || ''} ${lastName}`,
      dateOfBirth: dob ? dateFormatters.normDateToShortAmericanDate(dob) : '',
      memberType: type,
    };
  }

  /** Atomic write; local state is updated from the payload (no GET refresh). */
  public async updateDependent(updatedData: SubscriberPersonInfo): Promise<void> {
    await addOrUpdateDependent(this._subscriberId, updatedData as PersonInfo);
    runInAction(() => {
      this._dependent = updatedData;
    });
  }

  constructor({ dependent, subscriberId }: DomainParams) {
    this._dependent = dependent;
    this._subscriberId = subscriberId;
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
